module.exports = __webpack_public_path__ + "static/karla-regular-a846d087381aa41ee81327229fd81dd0.woff2";